import React from 'react';

const OffIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: 'scale(1.3)'}}>
      <rect width="24" height="24" transform="translate(0 0.5)" fill="none"/>
      <rect x="0.5" y="1" width="23" height="23" rx="11.5" fill="white"/>
      <rect x="0.5" y="1" width="23" height="23" rx="11.5" stroke="#AAA2AA"/>
      <path d="M8.32801 7.49902C6.74593 8.65893 5.71387 10.5255 5.71387 12.6378C5.71387 16.1579 8.56772 19.0115 12.0878 19.0115C15.6082 19.0115 18.4618 16.1579 18.4618 12.6378C18.4618 10.5255 17.43 8.65893 15.8476 7.49902" stroke="#4B1C46" strokeWidth="1.37143" strokeLinecap="round"/>
      <path d="M11.9451 5.646V11.9839" stroke="#4B1C46" strokeWidth="1.37143" strokeLinecap="round"/>
    </svg>

  );
};

export default OffIcon;
